import { IEventSessionType } from "../interfaces/IEventSessionType";
import { CrudService } from "./crudService";

export class EventSessionTypeService extends CrudService<IEventSessionType> {
    constructor(apiClient: any) {
        super(apiClient, '/admin/event-session-type');
    }
}